module.exports = __webpack_public_path__ + "img/SERVICE.0f79940c.png";